import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-center p-8 text-gray-700">Lade Benutzer...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
